try{self['workbox:sw:7.1.0']&&_()}catch(e){}// eslint-disable-line